<template>
  <div class="wrap_con">
    <van-nav-bar @click-right="onClickRight">
      <template #left>
        <!-- <div >人员审核状态</div> -->
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item @change="getTeacherAuditList" v-model="value2" :options="option1" />
        </van-dropdown-menu>
      </template>
      <template #right>
        <div style="color: #646566">
          {{ selectText }}
          <van-icon name="arrow" color="#646566" />
        </div>
      </template>
    </van-nav-bar>
    <van-action-sheet v-model="statusShow" :actions="actions" cancel-text="取消" @select="onSelect" />

    <div class="wrap" v-if="ListData.length">
      <!-- 筛选条件 -->

      <div class="cardBox" v-if="approveStatus == 0">
        <van-list v-model="listLoading" :finished="page * 20 >= ListData.length" finished-text="没有更多了" @load="onLoad"
          :immediate-check="false">
          <div class="card" v-for="(item, index) in ListData.slice(0, page * 20)" :key="index">
            <div class="card-top" :style="{ paddingBottom: item.children.auditStatus == 2 ? '2vw' : '0' }">
              <div class="childState" style="display: flex;align-items: center;">
                <el-checkbox style="z-index: 0;" v-model="item.state" @change="SelectChange(item)"
                  v-if="item.children.auditStatus == 0" />
                <!-- <van-tag type="success" v-if="item.children.auditStatus == 1">已通过</van-tag>
                <van-tag type="danger" v-if="item.children.auditStatus == 2">已驳回</van-tag> -->
                <!-- <div v-else style="width: 0.875rem; height: 0.875rem"></div> -->
              </div>
              <div class="childAvatar">
                <el-image class="avatar-image" style="width: 10vw; height: 10vw; border-radius: 10vw"
                  :src="item.children.avatar" :preview-src-list="[item.children.avatar]">
                  <van-icon slot="error" name="contact" />
                </el-image>
              </div>
              <div class="childMsg">
                {{ item.children.name }}{{item.children.className ? ' - ' + item.children.className : ''}}（{{ ['','自行上放学','家长接送','小饭桌接送'][item.children.dismissalType] }}）
              </div>
            </div>
            <div class="card-center" v-if="item.children.auditStatus != 2">
              <div class="parItem" v-for="parItem in item.parents">
                <div class="parentState" style="display: flex;align-items: center;">
                  <el-checkbox style="z-index: 0;" v-model="parItem.state" @change="SelectChange()"
                    v-if="parItem.auditStatus == 0" />

                  <!-- <van-tag type="success" v-if="parItem.auditStatus == 1">已通过</van-tag>
                  <van-tag type="danger" v-if="parItem.auditStatus == 2">已驳回</van-tag> -->
                  <!-- <div v-else style="width: 0.875rem; height: 0.875rem"></div> -->
                </div>
                <div class="parentAvatar">
                  <el-image class="avatar-image" style="width: 8vw; height: 8vw; border-radius: 10vw"
                    :src="parItem.avatar" :preview-src-list="[parItem.avatar]">
                    <van-icon slot="error" name="contact" />
                  </el-image>
                </div>
                <div class="parentName">
                  <span v-if="parItem.operationType == 2" style="color: rgb(253, 124, 148)">申请删除：</span>
                  {{ parItem.name }}
                </div>
                <div class="parentTel">
                  <span v-if="!parItem.isShowMobile">{{ parItem.tel }}</span>
                  <span v-if="parItem.isShowMobile">{{ parItem.noMobile }}</span>

                  <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                    @click="getTeacherOrParentMobile(parItem, parItem.isShowMobile)" v-if="parItem.isShowMobile"
                    name="eye-o" />
                  <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                    @click="getTeacherOrParentMobile(parItem, parItem.isShowMobile)" v-if="!parItem.isShowMobile"
                    name="closed-eye" />

                </div>
              </div>
            </div>

            <!-- 待审核 -->
            <div class="card-bottom" v-if="approveStatus == 0">
              <div class="applyDate">申请时间：{{ item.date | date }}</div>
              <div class="Btn">
                <button class="rejectBtn" @click="showHiddenBox('item', getSelectData(item))">
                  <span>驳回</span>
                </button>
                <button class="resolveBtn" @click="SubmitItem(getSelectData(item))">
                  <span>通过</span>
                </button>
              </div>
            </div>
            <!-- 已通过  -->
            <div class="card-bottom" style="padding-left: 10px;justify-content: space-between;"
              v-if="approveStatus == 1">
              <div class="applyDate" style="width: 48%;">审核人：{{ item.auditUser }}</div>
              <div class="applyDate" style="width: 56%;">通过时间：{{ item.auditDate | date }}</div>
            </div>

            <!-- 已驳回 -->
            <div class="card-bottom" style="padding-left: 10px;justify-content: space-between;"
              v-if="approveStatus == 2">
              <div class="applyDate" style="width: 48%;">审核人：{{ item.auditUser }}</div>
              <div class="applyDate" style="width: 56%;">驳回时间：{{ item.auditDate | date }}</div>

            </div>
            <div class="card-bottom" style="padding-left: 25px;justify-content: space-between;"
              v-if="(approveStatus == 1 || approveStatus == 2) && item.auditRemark">
              <div style=" font-size: 2.8vw;color: rgba(0, 0, 0, 0.6);width: 100%;">审核理由：{{ item.auditRemark }}</div>


              <div class="Btn">

              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="cardBox" v-if="approveStatus == 1">
        <van-list v-model="listLoading" :finished="listFinished" finished-text="没有更多了" @load="onLoad"
          :immediate-check="false">
          <div class="card" v-for="(item, index) in ListData" :key="index">
            <div class="card-top" :style="{ paddingBottom: item.children.auditStatus == 2 ? '2vw' : '0' }">
              <div class="childState" style="display: flex;align-items: center;">
                <el-checkbox style="z-index: 0;" v-model="item.state" @change="SelectChange(item)"
                  v-if="item.children.auditStatus == 0" />
                <!-- <van-tag type="success" v-if="item.children.auditStatus == 1">已通过</van-tag>
                <van-tag type="danger" v-if="item.children.auditStatus == 2">已驳回</van-tag> -->
                <!-- <div v-else style="width: 0.875rem; height: 0.875rem"></div> -->
              </div>
              <div class="childAvatar">
                <el-image class="avatar-image" style="width: 10vw; height: 10vw; border-radius: 10vw"
                  :src="item.children.avatar" :preview-src-list="[item.children.avatar]">
                  <van-icon slot="error" name="contact" />
                </el-image>
              </div>
              <div class="childMsg">
                {{ item.children.name }}（{{ item.children.className }}）
              </div>
            </div>
            <div class="card-center" v-if="item.children.auditStatus != 2">
              <div class="parItem" v-for="parItem in item.parents">
                <div class="parentState" style="display: flex;align-items: center;">
                  <el-checkbox style="z-index: 0;" v-model="parItem.state" @change="SelectChange()"
                    v-if="parItem.auditStatus == 0" />

                  <!-- <van-tag type="success" v-if="parItem.auditStatus == 1">已通过</van-tag>
                  <van-tag type="danger" v-if="parItem.auditStatus == 2">已驳回</van-tag> -->
                  <!-- <div v-else style="width: 0.875rem; height: 0.875rem"></div> -->
                </div>
                <div class="parentAvatar">
                  <el-image class="avatar-image" style="width: 8vw; height: 8vw; border-radius: 10vw"
                    :src="parItem.avatar" :preview-src-list="[parItem.avatar]">
                    <van-icon slot="error" name="contact" />
                  </el-image>
                </div>
                <div class="parentName">
                  <span v-if="parItem.operationType == 2" style="color: rgb(253, 124, 148)">申请删除：</span>
                  {{ parItem.name }}
                </div>
                <div class="parentTel">
                  <span v-if="!parItem.isShowMobile">{{ parItem.tel }}</span>
                  <span v-if="parItem.isShowMobile">{{ parItem.noMobile }}</span>

                  <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                    @click="getTeacherOrParentMobile(parItem, parItem.isShowMobile)" v-if="parItem.isShowMobile"
                    name="eye-o" />
                  <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                    @click="getTeacherOrParentMobile(parItem, parItem.isShowMobile)" v-if="!parItem.isShowMobile"
                    name="closed-eye" />

                </div>
              </div>
            </div>

            <!-- 待审核 -->
            <div class="card-bottom" v-if="approveStatus == 0">
              <div class="applyDate">申请时间：{{ item.date | date }}</div>
              <div class="Btn">
                <button class="rejectBtn" @click="showHiddenBox('item', getSelectData(item))">
                  <span>驳回</span>
                </button>
                <button class="resolveBtn" @click="SubmitItem(getSelectData(item))">
                  <span>通过</span>
                </button>
              </div>
            </div>
            <!-- 已通过  -->
            <div class="card-bottom" style="padding-left: 10px;justify-content: space-between;"
              v-if="approveStatus == 1">
              <div class="applyDate" style="width: 48%;">审核人：{{ item.auditUser }}</div>
              <div class="applyDate" style="width: 56%;">通过时间：{{ item.auditDate | date }}</div>
            </div>

            <!-- 已驳回 -->
            <div class="card-bottom" style="padding-left: 10px;justify-content: space-between;"
              v-if="approveStatus == 2">
              <div class="applyDate" style="width: 48%;">审核人：{{ item.auditUser }}</div>
              <div class="applyDate" style="width: 56%;">驳回时间：{{ item.auditDate | date }}</div>

            </div>
            <div class="card-bottom" style="padding-left: 25px;justify-content: space-between;"
              v-if="(approveStatus == 1 || approveStatus == 2) && item.auditRemark">
              <div style=" font-size: 2.8vw;color: rgba(0, 0, 0, 0.6);width: 100%;">审核理由：{{ item.auditRemark }}</div>


              <div class="Btn">

              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="cardBox" v-if="approveStatus == 2">
        <van-list v-model="listLoading" :finished="listFinished" finished-text="没有更多了" @load="onLoad"
          :immediate-check="false">
          <div class="card" v-for="(item, index) in ListData" :key="index">
            <div class="card-top" :style="{ paddingBottom: item.children.auditStatus == 2 ? '2vw' : '0' }">
              <div class="childState" style="display: flex;align-items: center;">
                <el-checkbox style="z-index: 0;" v-model="item.state" @change="SelectChange(item)"
                  v-if="item.children.auditStatus == 0" />
                <!-- <van-tag type="success" v-if="item.children.auditStatus == 1">已通过</van-tag>
                <van-tag type="danger" v-if="item.children.auditStatus == 2">已驳回</van-tag> -->
                <!-- <div v-else style="width: 0.875rem; height: 0.875rem"></div> -->
              </div>
              <div class="childAvatar">
                <el-image class="avatar-image" style="width: 10vw; height: 10vw; border-radius: 10vw"
                  :src="item.children.avatar" :preview-src-list="[item.children.avatar]">
                  <van-icon slot="error" name="contact" />
                </el-image>
              </div>
              <div class="childMsg">
                {{ item.children.name }}（{{ item.children.className }}）
              </div>
            </div>
            <div class="card-center" v-if="item.children.auditStatus != 2">
              <div class="parItem" v-for="parItem in item.parents">
                <div class="parentState" style="display: flex;align-items: center;">
                  <el-checkbox style="z-index: 0;" v-model="parItem.state" @change="SelectChange()"
                    v-if="parItem.auditStatus == 0" />

                  <!-- <van-tag type="success" v-if="parItem.auditStatus == 1">已通过</van-tag>
                  <van-tag type="danger" v-if="parItem.auditStatus == 2">已驳回</van-tag> -->
                  <!-- <div v-else style="width: 0.875rem; height: 0.875rem"></div> -->
                </div>
                <div class="parentAvatar">
                  <el-image class="avatar-image" style="width: 8vw; height: 8vw; border-radius: 10vw"
                    :src="parItem.avatar" :preview-src-list="[parItem.avatar]">
                    <van-icon slot="error" name="contact" />
                  </el-image>
                </div>
                <div class="parentName">
                  <span v-if="parItem.operationType == 2" style="color: rgb(253, 124, 148)">申请删除：</span>
                  {{ parItem.name }}
                </div>
                <div class="parentTel">
                  <span v-if="!parItem.isShowMobile">{{ parItem.tel }}</span>
                  <span v-if="parItem.isShowMobile">{{ parItem.noMobile }}</span>

                  <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                    @click="getTeacherOrParentMobile(parItem, parItem.isShowMobile)" v-if="parItem.isShowMobile"
                    name="eye-o" />
                  <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                    @click="getTeacherOrParentMobile(parItem, parItem.isShowMobile)" v-if="!parItem.isShowMobile"
                    name="closed-eye" />

                </div>
              </div>
            </div>

            <!-- 待审核 -->
            <div class="card-bottom" v-if="approveStatus == 0">
              <div class="applyDate">申请时间：{{ item.date | date }}</div>
              <div class="Btn">
                <button class="rejectBtn" @click="showHiddenBox('item', getSelectData(item))">
                  <span>驳回</span>
                </button>
                <button class="resolveBtn" @click="SubmitItem(getSelectData(item))">
                  <span>通过</span>
                </button>
              </div>
            </div>
            <!-- 已通过  -->
            <div class="card-bottom" style="padding-left: 10px;justify-content: space-between;"
              v-if="approveStatus == 1">
              <div class="applyDate" style="width: 48%;">审核人：{{ item.auditUser }}</div>
              <div class="applyDate" style="width: 56%;">通过时间：{{ item.auditDate | date }}</div>
            </div>

            <!-- 已驳回 -->
            <div class="card-bottom" style="padding-left: 10px;justify-content: space-between;"
              v-if="approveStatus == 2">
              <div class="applyDate" style="width: 48%;">审核人：{{ item.auditUser }}</div>
              <div class="applyDate" style="width: 56%;">驳回时间：{{ item.auditDate | date }}</div>

            </div>
            <div class="card-bottom" style="padding-left: 25px;justify-content: space-between;"
              v-if="(approveStatus == 1 || approveStatus == 2) && item.auditRemark">
              <div style=" font-size: 2.8vw;color: rgba(0, 0, 0, 0.6);width: 100%;">审核理由：{{ item.auditRemark }}</div>


              <div class="Btn">

              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="sendBox" v-if="approveStatus == 0">
        <div class="allState">
          <el-checkbox v-model="allState" @change="allChange()">
            全选
          </el-checkbox>
        </div>



        <div class="selectMsg" v-if="value2 == 0">
          （已选{{ childNum }}个学生，{{ parentNum }}个家长）
        </div>
        <div class="selectMsg" v-if="value2 == 1">
          （已选{{ childNum }}个老师）
        </div>


        <div class="Btn">
          <button class="rejectAll" @click="showHiddenBox('all', getSelectData(ListData))">
            <span>驳回</span>
          </button>
          <button class="resolveAll" @click="SubmitAll(getSelectData(ListData))">
            <span>通过</span>
          </button>
        </div>
      </div>
      <van-dialog v-model="show" title="" :show-cancel-button="!dlLoading" :show-confirm-button="!dlLoading"
        confirmButtonColor="rgb(107, 178, 250)" @confirm="reject()" @close="clearReject()" @cancel="closeBox"
        :before-close="beforeClose">
        <div class="progress-box" v-if="dlLoading">
          <p>处理中</p>
          <van-circle v-model="progress" layer-color="#F5F7FA" :rate="1" :speed="100" :text="progressText" />
        </div>

        <div class="hiddenBox" v-else>
          <p>请输入驳回原因</p>
          <textarea type="text" v-model="text" />
        </div>
      </van-dialog>
    </div>
    <div class="empty" v-else>
      <van-empty description="暂无数据" />
    </div>
    <van-popup v-model="loading" :close-on-click-overlay="false"><van-loading color="#1989fa" /></van-popup>
  </div>
</template>

<script>
import moment from "moment";
import * as constant from '@/constant';
export default {
  name: "personnel",
  data() {
    return {
      ListData: [],
      allState: false,
      show: false,
      text: "",
      rejectType: "",
      rejectData: "",
      closeState: true,
      listFinished: false,
      progress: 1,
      listLoading: false,
      loading: false,
      dlLoading: false,
      page: 1,
      // 选中的状态
      selectText: '待审核',
      approveStatus: 0,
      name: '',
      value2: 0,
      option1: [
        { text: '学生', value: 0 },
        { text: '老师', value: 1 }
      ],
      actions: [
        {
          name: '待审核'
        },
        {
          name: '已通过'
        },
        {
          name: '已驳回'
        }
      ],
      statusShow: false,
      // 已通过和已驳回使用分页
      pageNum: 1,
      totalPage: 0
    };
  },
  mounted() {
    this.getListData();
    console.log();
    document.addEventListener("touchstart", function () { }, false);
    console.log(this._data, 3333);
  },
  filters: {
    date(date) {
      return moment(date).format("YYYY/MM/DD HH:mm");
    },
  },
  computed: {
    progressText() {
      return this.progress + '%'
    },
    childNum() {
      let num = 0;
      this.ListData.forEach((item) => {
        if (item.state) {
          num++;
        }
      });
      return num;
    },
    parentNum() {
      let num = 0;
      this.ListData.forEach((item) => {
        item.parents && item.parents.forEach((items) => {
          if (items.state && items.auditStatus == 0) {
            num++;
          }
        });
      });
      return num;
    },
  },
  methods: {
    // 点击显示选择状态
    onClickRight() {
      this.statusShow = true;
    },


    // 选择请假状态后
    onSelect(item) {
      let obj = {
        待审核: 0,
        已通过: 1,
        已驳回: 2
      };
      this.approveStatus = obj[item.name]
      this.selectText = item.name;
      this.pageNum = 1;
      this.totalPage = 0;
      this.statusShow = false
      if (this.value2 == 1) { // 查询老师

        // 根据状态判断调用接口
        if (this.approveStatus == 0) {
          this.getTeacherLlistData()
        } else if (this.approveStatus == 1 || this.approveStatus == 2) {
          this.ListData = []
          // 获取老师新信息(分页部分)
          this.getTeacherLlistDataPage()
        }
       
      } else { // 查询学生和家长
        if (this.approveStatus == 0) {
          this.getListData()
        } else if (this.approveStatus == 1 || this.approveStatus == 2) {
          this.ListData = []
          this.getListDataPage()
        }
       
      }

    },

    // 获取老师待审批数据列表
    async getTeacherAuditList(value) {
      console.log('value',value,this.approveStatus)
      if (value == 1) { // value == 1 查询老师
        // 根据当前的状态判断是否调用分页接口
        if (this.approveStatus == 0) {
          this.getTeacherLlistData()
        } else if (this.approveStatus == 1 || this.approveStatus == 2) {
          this.ListData = []
          this.pageNum = 1
          this.totalPage = 0
          this.getTeacherLlistDataPage()
        }
        
      } else { //value == 0 查询学生和家长
        if (this.approveStatus == 0) {
          this.getListData()
        } else if (this.approveStatus == 1 || this.approveStatus == 2) {
          this.ListData = []
          this.pageNum = 1
          this.totalPage = 0

          this.getListDataPage()
        }
       
      }

    },

    onLoad() {
      if (this.approveStatus == 0) {

        this.page++
        console.log(this.page, 'this.page')
        setTimeout(() => {
          this.listLoading = false
        }, 200);

      } else if (this.approveStatus == 1 || this.approveStatus == 2) {
        if (this.value2 == 1) { // 老师
          if (this.pageNum >= this.totalPage) {
          this.listFinished = true
        } else {
          this.pageNum = this.pageNum + 1
          this.getTeacherLlistDataPage()
        }
        } else if (this.value2 == 0) { // 学生
          if (this.pageNum >= this.totalPage) {
          this.listFinished = true
        } else {
          this.pageNum = this.pageNum + 1
          this.getListDataPage()
        }
        }
        
      
      }

    },

    // 获取学生和家长待审批列表 (待审批不分页)
    async getListData() {
      this.loading = true;
      const { code, data } = await this.$https.getPendingUserTemporaryAudit({
        schoolId: this.$store.state.schoolId,
        auditStatus: this.approveStatus,
        userId: this.$store.state.userId,
      });
      if (!code == 200 || !data) {
        this.loading = false;
        this.$emit("personnelLoading", false);
        return false;
      }
      this.ListData = data.map((item) => {
        return {
            children: {
              name: item.name, //姓名
              avatar: item.avatar, //识别头像
              className: item.className, //班级名称
              id: item.id, //id
              classId: item.classId, //班级id
              auditStatus: item.auditStatus, //审核状态
              remark: item.remark, //信息
              dismissalType:item.dismissalType,
              recordId: item.recordId, //审核id
              schoolId: item.schoolId, //学校id
            },
            parents: item.parentTemporary && item.parentTemporary.map((par) => {
              par.isShowMobile = false
              par.state = false;
              par.tel = par.mobile;
              par.avatar = par.avatar
                ? par.avatar
                : "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3066521747,2732939006&fm=26&gp=0.jpg";
              return par;
            }), //家长信息列表
            state: false,
            auditUser: item.auditUser,
            auditStatus: item.auditStatus,
            auditRemark: item.auditRemark,
            date: item.createdTime, //申请时间
            auditDate: item.lastModifiedTime, //申请时间

          };

      });
      this.ListData = this.ListData.filter((item) => item);
      console.log(this.ListData);
      this.$emit("ListData", JSON.parse(JSON.stringify(this.ListData)));
      this.$emit("personnelLoading", false);

      this.setTabBadge();
      this.statusShow = false
      this.loading = false;
    },

    // 获取老师审批列表 (待审批不分页)
    async getTeacherLlistData() {
      this.loading = true;
      let { code, data } = await this.$https.getUserTemporaryAudit({
        schoolId: this.$store.state.schoolId,
        auditStatus: this.approveStatus,
        userId: this.$store.state.userId,
      });
      if (!data) {
        data = []
      }
      if (!code == 200 || !data) {
        this.loading = false;
        this.$emit("personnelLoading", false);
        return false;
      }
      this.ListData = data.map((item) => {
        return {
          children: {
            name: item.name, //姓名
            avatar: item.avatar, //识别头像
            className: item.className, //班级名称
            id: item.id, //id
            classId: item.classId, //班级id
            auditStatus: item.auditStatus, //审核状态
            remark: item.remark, //信息

            recordId: item.recordId, //审核id
            schoolId: item.schoolId, //学校id
          },
          state: false,
          auditUser: item.auditUser,
          auditStatus: item.auditStatus,
          auditRemark: item.auditRemark,
          date: item.temporaryTime, //申请时间
          auditDate: item.lastModifiedTime, //通过/驳回时间

        };
      });
      this.ListData = this.ListData.filter((item) => item);
      console.log(this.ListData);
      this.$emit("ListData", JSON.parse(JSON.stringify(this.ListData)));
      this.$emit("personnelLoading", false);

      this.setTabBadge();
      this.statusShow = false
      this.loading = false;
    },

    // 获取学生和家长待审批列表 (通过|驳回 分页)
    async getListDataPage() {
      this.loading = true;
      const { code, data } = await this.$https.getPendingUserTemporaryAuditPage({
        schoolId: this.$store.state.schoolId,
        auditStatus: this.approveStatus,
        pageNum: this.pageNum,
        userId: this.$store.state.userId,
      });
      if (!code == 200 || !data) {
        this.loading = false;
        this.$emit("personnelLoading", false);
        return false;
      }
      
      let newList = data.list && data.list.map((item) => {
        return {
          children: {
            name: item.name, //姓名
            avatar: item.avatar, //识别头像
            className: item.className, //班级名称
            id: item.id, //id
            classId: item.classId, //班级id
            auditStatus: item.auditStatus, //审核状态
            remark: item.remark, //信息

            recordId: item.recordId, //审核id
            schoolId: item.schoolId, //学校id
          },
          parents: item.parentTemporary && item.parentTemporary.map((par) => {
            par.isShowMobile = false
            par.state = false;
            par.tel = par.mobile;
            par.avatar = par.avatar
              ? par.avatar
              : "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3066521747,2732939006&fm=26&gp=0.jpg";
            return par;
          }), //家长信息列表
          state: false,
          auditUser: item.auditUser,
          auditStatus: item.auditStatus,
          auditRemark: item.auditRemark,
          date: item.createdTime, //申请时间
          auditDate: item.lastModifiedTime, //申请时间

        };
      });
      if (!this.totalPage) {
        this.totalPage = data.totalPage
      }
      
      this.listLoading = false
      this.ListData = [...this.ListData, ...newList].filter((item) => item);
      
      this.$emit("ListData", []);
      this.$emit("personnelLoading", false);

      this.setTabBadge();
      this.statusShow = false
      this.loading = false;
    },

    // 获取老师审批列表 (通过|驳回 分页)
    async getTeacherLlistDataPage() {
      this.loading = true;
      let { code, data } = await this.$https.getUserTemporaryAuditPage({
        schoolId: this.$store.state.schoolId,
        auditStatus: this.approveStatus,
        pageNum:this.pageNum,
        userId: this.$store.state.userId,
      });
      if (!data) {
        data = []
      }
      if (!code == 200 || !data) {
        this.loading = false;
        this.$emit("personnelLoading", false);
        return false;
      }
      
     
      let newList = data.list && data.list.map((item) => {
        return {
          children: {
            name: item.name, //姓名
            avatar: item.avatar, //识别头像
            className: item.className, //班级名称
            id: item.id, //id
            classId: item.classId, //班级id
            auditStatus: item.auditStatus, //审核状态
            remark: item.remark, //信息

            recordId: item.recordId, //审核id
            schoolId: item.schoolId, //学校id
          },
          state: false,
          auditUser: item.auditUser,
          auditStatus: item.auditStatus,
          auditRemark: item.auditRemark,
          date: item.temporaryTime, //申请时间
          auditDate: item.lastModifiedTime, //通过/驳回时间

        };
      });
      if (!this.totalPage) {
        this.totalPage = data.totalPage
      }
      
      this.listLoading = false
      this.ListData = [...this.ListData, ...newList].filter((item) => item);
      this.$emit("ListData", []);
      this.$emit("personnelLoading", false);

      this.setTabBadge();
      this.statusShow = false
      this.loading = false;
    },

    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getUserTemporaryMobileById({
          id: data.id
        }).then(res => {
          if (res.code == 200) {

            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },
    allChange() {
      if (this.allState) {
        this.ListData.forEach((child) => {
          if (child.children.auditStatus == 0) {
            child.state = true;
          }
          child.parents && child.parents.forEach((parent) => {
            parent.state = true;
          });
        });
      } else {
        this.ListData.forEach((child) => {
          child.state = false;
          child.parents && child.parents.forEach((parent) => {
            parent.state = false;
          });
        });
      }
    },
    SelectChange(data = "") {
      let state = true;
      if (data && data.state) {
        data.parents && data.parents.forEach((item) => {
          item.state = true;
        });
      }
      this.ListData && this.ListData.forEach((item) => {
        if (!item.state) {
          state = false;
        }
        item.parents && item.parents.forEach((items) => {
          if (!items.state) {
            state = false;
          }
        });
      });
      this.allState = state;
    },
    getSelectData(data) {
      console.log('获取当前选中的审批数据', data)
      let Data = JSON.parse(JSON.stringify(data));
      let SelectData = {};
      if (Array.isArray(Data)) {
        SelectData = Data && Data.map((child) => {
          let obj = {};
          obj.parents = child.parents && child.parents.map((parent) => {
            if (parent.state) {
              return parent;
            } else {
              return null;
            }
          });
          obj.parents = obj.parents && obj.parents.filter((item) => item);
          obj.parents && obj.parents.length ? "" : delete obj.parents;
          if (child.state) {
            obj.children = child.children;
          }
          if (!obj.children && !obj.parents) {
            obj = null;
          }
          return obj;
        });
        SelectData = SelectData && SelectData.filter((item) => item);
      } else {
        SelectData.parents = Data.parents && Data.parents.map((parent) => {
          if (parent.state) {
            return parent;
          } else {
            return null;
          }
        });
        SelectData.parents = SelectData.parents && SelectData.parents.filter((item) => item);
        SelectData.parents && SelectData.parents.length ? "" : delete SelectData.parents;
        if (Data.state) {
          SelectData.children = Data.children;
        }
        if (!SelectData.children && !SelectData.parents) {
          SelectData = "";
        } else {
          SelectData = [SelectData];
        }

        // if (Data.children && !Data.parents) {
        //   SelectData = {
        //     children: Data.children,
        //   };
        // }
      }
      console.log(SelectData);
      return SelectData;
    },
    showHiddenBox(type, data) {
      if ((type == "item" && data[0]) || (type == "all" && data.length)) {
        this.show = true;
        this.rejectType = type;
        this.rejectData = data;
      } else {
        this.$toast("请选择人员后操作");
      }
    },
    clearReject() {
      this.text = "";
      this.rejectType = "";
      this.rejectData = "";
      this.closeState = true;
    },
    reject() {
      if (!this.text) {
        this.closeState = false;
        this.$toast("请输入驳回原因");
        return false;
      } else {
        this.closeState = true;
      }
      if (!this.rejectData.length) {
        return false;
      }
      let arr = new Array();
      this.rejectData.forEach((item) => {
        if (item.children) {
          arr.push(item.children.id);
        }
        if (item.parents) {
          item.parents && item.parents.forEach((items) => {
            arr.push(items.id);
          });
        }
      });
      let parmas = {
        auditStatus: 2,
        remark: this.text,
        userId: this.$store.state.userId,
        ids: arr,
      };
      this.resolve(parmas);
    },
    SubmitItem(data) {
      if (!data || (!data[0].children && !data[0].parents)) {
        this.$toast("请选择人员后操作");
      } else {
        let arr = new Array();
        data.forEach((item) => {
          if (item.children) {
            arr.push(item.children.id);
          }
          if (item.parents) {
            item.parents && item.parents.forEach((items) => {
              arr.push(items.id);
            });
          }
        });
        let parmas = {
          auditStatus: 1,
          remark: this.text,
          userId: this.$store.state.userId,
          ids: arr,
        };
        this.resolve(parmas);
      }
    },
    SubmitAll(data) {
      if (!data.length) {
        this.$toast("请选择人员后操作");
      } else {
        let arr = new Array();
        data.forEach((item) => {
          if (item.children) {
            arr.push(item.children.id);
          }
          if (item.parents) {
            item.parents && item.parents.forEach((items) => {
              arr.push(items.id);
            });
          }
        });
        let parmas = {
          auditStatus: 1,
          remark: this.text,
          userId: this.$store.state.userId,
          ids: arr,
        };
        this.resolve(parmas);
      }
    },
    async resolve(parmas) {
      try {
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          message: '处理中...',
          forbidClick: true,
        });
        const { code, data } = await this.$https.batchApproval({ ...parmas });
        this.$toast?.clear?.();
        this.show = false;
        this.dlLoading = false;
        this.progress = 100;
        if (!code == 200) {
          return false;
        } else {
          if (this.value2 == 1) {
            this.getTeacherLlistData();
          } else {
            this.getListData();
          }

          setTimeout(() => {
            this.$toast("成功");
          }, 200);
        }
      } catch (error) {
        this.$toast?.clear?.();
        this.$toast("处理失败请重试");
        this.show = false;
        this.dlLoading = false;
      }
    },
    setTabBadge() {
      if (this.approveStatus == 1 || this.approveStatus == 2) {
        this.$store.commit("setTabBadge", {
          type: "personnel",
          value: 0,
        });
      } else {
        this.$store.commit("setTabBadge", {
          type: "personnel",
          value: this.ListData.length,
        });
      }

    },
    beforeClose(action, done) {
      if (!this.closeState || this.dlLoading) {
        done(false);
      } else {
        done();
      }
    },
    closeBox() {
      this.closeState = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap_con {
  // position: relative;
  // top: 0;
  // // background-color: red;
  // bottom: 0;
  // left: 0;
  // right: 0;
  background-color: #f7f7fa;

  ::v-deep .van-dropdown-menu .van-dropdown-menu__bar {
    box-shadow: none;
    height: 100%;
  }

  ::v-deep .van-dropdown-menu .van-dropdown-menu__bar {
    box-shadow: none;
    height: 100%;
  }

  ::v-deep .van-dropdown-menu .van-dropdown-menu__bar .van-dropdown-menu__title {
    font-size: 0.875rem;
  }


  ::v-deep .van-dropdown-menu .van-dropdown-item--down .van-popup .van-cell {
    padding: 1.6rem 1.4rem 1rem 1.6rem
  }
}

.wrap {
  font-family: "Microsoft YaHei";

  .cardBox {
    margin-top: 3vw;
    padding-bottom: 10vw;
    position: relative;

    .card {
      margin-bottom: 3vw;
      background: white;
      width: 90%;
      margin-left: 5%;
      border-radius: 2vw;
      padding-top: 2vw;

      .card-top {
        display: flex;
        justify-content: left;
        align-items: center;
        padding-left: 3vw;

        .childAvatar {
          margin-left: 3vw;
        }

        .childMsg {
          font-size: 4vw;
          transform: scale(0.9);
        }
      }

      .card-center {
        padding-bottom: 2vw;

        .parItem {
          display: flex;
          justify-content: left;
          align-items: center;
          padding-left: 12vw;

          .parentAvatar {
            margin-left: 3vw;
          }

          .parentName {
            transform: scale(0.8);
            font-size: 3.7vw;
            color: rgba(0, 0, 0, 0.6);
            width: 38vw;
          }

          .parentTel {
            position: absolute;
            right: 9vw;
            transform: scale(0.8);
            font-size: 3.7vw;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }

      .card-bottom {
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 3vw 0;
        border-top: 1px solid rgba(0, 0, 0, 0.05);

        .applyDate {
          font-size: 3.5vw;
          transform: scale(0.8);
          color: rgba(0, 0, 0, 0.6);
        }

        .Btn {
          position: absolute;
          right: 7vw;

          span {
            font-size: 3.5vw;
            display: inline-block;
            transform: scale(0.8) translate(0, -5%);
            color: rgba(255, 255, 255, 0.8);
          }

          button {
            width: 16vw;
            padding: 0;
            border-radius: 5vw;
            border: none;
            margin: 0 1vw;
          }

          .rejectBtn {
            background: rgb(230, 123, 41);
          }

          .resolveBtn {
            background: rgb(26, 136, 249);
          }
        }
      }
    }
  }

  .sendBox {
    display: flex;
    justify-content: left;
    align-items: center;
    height: 13vw;
    width: 100%;
    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.1);
    position: fixed;
    bottom: 0;
    left: 0;
    padding-left: 5vw;
    background: white;
    z-index: 10;

    .allState {
      margin-right: .25rem;
    }

    .allSelect {
      margin-left: 2vw;
      font-size: 4.5vw;
      transform: scale(0.9);
    }

    .selectMsg {
      font-size: 3.5vw;
      transform: scale(0.8) translate(-4vw, 0);
      color: rgb(112, 180, 250);
    }

    .Btn {
      position: absolute;
      right: 5vw;

      button {
        border: none;
        width: 16vw;
        height: 7vw;
        border-radius: 7vw;
        padding: 0;
      }

      span {
        font-size: 4vw;
        display: inline-block;
        transform: scale(0.8);
        color: rgba(255, 255, 255, 0.8);
      }

      .rejectAll {
        background: rgb(230, 123, 41);
        margin-right: 2vw;
      }

      .resolveAll {
        background: rgb(26, 136, 249);
      }
    }
  }

  .hiddenBox {
    width: 100%;
    height: 50vw;
    padding-bottom: 5vw;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    p {
      margin: 0;
      padding: 4vw;
      text-align: center;
    }

    textarea {
      box-sizing: border-box;
      width: 80%;
      margin-left: 10%;
      height: 72%;
      border: none;
      outline: none;
      background: rgb(246, 246, 246);
      padding: 3vw;
      border-radius: 2vw;
      resize: none;
    }
  }
}

button:active {
  opacity: 0.7;
}

.empty {
  height: 90vh;
}

::v-deep .van-popup {
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}

.progress-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: .75rem 0;

  >p {
    margin-bottom: 1rem;
  }
}

.avatar-image {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F1F2F6;
  color: #C4C4C4;
}
</style>